"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetryableHttpClient = void 0;
const default_http_client_1 = require("../default-http.client");
const retry_helper_1 = require("../../helpers/retry.helper");
class RetryableHttpClient {
    static newInstance(options, retryOptions) {
        return new RetryableHttpClient(new default_http_client_1.DefaultHttpClient(options), retryOptions);
    }
    constructor(client, options = {}) {
        this.client = client;
        this.options = options;
    }
    withRetry(request, options, retryOptions = this.options) {
        retryOptions.times = retryOptions.times ? retryOptions.times : 0;
        retryOptions.delay = retryOptions.delay ? retryOptions.delay : 100;
        return retryOptions.when
            ? this.withRetryWhen(request, options, retryOptions)
            : this.withRetryWhen(request, options, {
                ...retryOptions,
                when: () => Promise.resolve(true),
            });
    }
    withRetryWhen(request, options, retryOptions = this.options) {
        return (0, retry_helper_1.retryWithDelay)(request, retryOptions.times, retryOptions.delay, retryOptions.when, options);
    }
    request(options, retryOptions) {
        return this.withRetry(() => this.client.request(options), options, retryOptions);
    }
    get(url, options, retryOptions) {
        return this.withRetry(() => this.client.get(url, options), options, retryOptions);
    }
    delete(url, options, retryOptions) {
        return this.withRetry(() => this.client.delete(url, options), options, retryOptions);
    }
    head(url, options, retryOptions) {
        return this.withRetry(() => this.client.head(url, options), options, retryOptions);
    }
    post(url, data, options, retryOptions) {
        return this.withRetry(() => this.client.post(url, data, options), options, retryOptions);
    }
    put(url, data, options, retryOptions) {
        return this.withRetry(() => this.client.put(url, data, options), options, retryOptions);
    }
    patch(url, data, options, retryOptions) {
        return this.withRetry(() => this.client.patch(url, data, options), options, retryOptions);
    }
}
exports.RetryableHttpClient = RetryableHttpClient;
//# sourceMappingURL=retryable-http.client.js.map